<template>
  <b-card :header="$t('project.alarmsExport.currentAlarms')">
    <div v-if="errored" class="alert alert-danger">{{errored}}</div>
    <div v-if="informed" class="alert alert-success">{{informed}}</div>
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-stations
            variant="info"
          >{{ $t('project.alarmsExport.selectStations') }}</b-button>
        </b-card-header>
        <b-collapse
          id="accordion-stations"
          visible
          accordion="accordion"
          v-model="accStations"
          role="tabpanel"
        >
          <b-card-body>
            <b-form-group>
              <b-button size="sm" class="mb-2" @click="selectAllStations()" >{{ $t('project.alarmsExport.selectAll') }}</b-button>
              <b-form-checkbox-group id="stations" v-model="selectedStations" stacked>
                  <b-form-checkbox v-for="(value, key) in stations" :key="key" :value="value.item1">{{ value.item2 }}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-button
              class="mt-3"
              block
              variant="success"
              @click="selectStations()"
            >{{ $t('project.alarmsExport.selectStationsConfirm') }}</b-button>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-alarms
            variant="info"
          >{{ $t('project.alarmsExport.currentAlarms') }}</b-button>
        </b-card-header>
        <b-collapse id="accordion-alarms" accordion="accordion" v-model="accAlarms" role="tabpanel">
          <b-card-body>
            <b-row>
              <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" :label="$t('other.filter')" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('other.searchHolder')"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">{{ $t('other.clear') }}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" :label="$t('other.perPage')" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              show-empty
              responsive
              small
              striped
              hover
              :items="currentAlarms"
              :fields="alarmsFields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              thead-class="d-none"
              @filtered="onFiltered"
            >
              <template #cell(date)="row">
                {{ getFormatDateString(row.item.alarm.mark) }}
              </template>
              <template #cell(status)="row">
                {{ getAlarmStatusString(row.item.alarm.value) }}
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <project-back-button />
  </b-card>
</template>

<script>
import { exportService } from "@/_services";
import { errorHandler } from "@/_helpers";
import { router } from "@/router";
import ProjectBackButton from "@/components/projects/ProjectBackButton";

export default {
  name: "ProjectCurrentAlarms",
  components: {
    projectBackButton: ProjectBackButton
  },
  data() {
    return {
      projectId: null,
      stations: [],
      errored: null,
      informed: null,
      selectedStations: [],
      currentAlarms: [],
      accStations: true,
      accAlarms: false,
      currentPage: 1,
      filter: null,
      totalRows: null,
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      alarmsFields: [
        { key: "date", label: "" },
        { key: "module", label: "" },
        { key: "object", label: "" },
        { key: "description", label: "" },
        { key: "status", label: "", variant: "danger" }
      ]
    };
  },
  created() {
    this.projectId = parseInt(this.$route.params.projectId, 10);
    if (isNaN(this.projectId) || this.projectId < 0) {
      router.push("/error404");
      return;
    }

    exportService
      .getStationsForProjects(this.projectId)
      .then(response => {
        this.stations = response.data;
      })
      .catch(error => {
        this.errored = errorHandler(error);
      });
  },
  methods: {
    getFormatDateString(value) {
      return new Date(value + "Z").toUTCString();
    },
    getAlarmStatusString(value) {
      return value === 0 ? "----OK----" : "-ERROR-";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    selectAllStations() {
      if (this.stations.length == this.selectedStations.length) {
        this.selectedStations = [];
        return;
      }
      this.selectedStations = [];
      for (let i = 0; i < this.stations.length; i++) {
        this.selectedStations.push(this.stations[i].item1);
      }
    },
    selectStations() {
      this.errored = null;
      this.informed = null;
      if (this.selectedStations.length === 0) return;
      let jsonData = JSON.stringify({ stations: this.selectedStations });
      exportService
        .getCurrentAlarms(this.projectId, jsonData)
        .then(response => {
          this.currentAlarms = response.data;
          this.accStations = false;
          this.accAlarms = true;
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
        .finally(() => {
          this.totalRows = this.currentAlarms.length;
          this.currentPage = 1;
          this.filter = null;
        });
    }
  }
};
</script>
